import React from "react";

export const NavigationContext = React.createContext({
        originPage: null,
        browsingPage: null,
        setOriginPage: () => {},
        setBrowsingPage: () => {},
})